import React from 'react';
import { Button } from '@/components/ui/button';
import { HelpCircle } from 'lucide-react';
import { useTutorial } from '@/contexts/TutorialContext';
import { cn } from '@/lib/utils';

interface TutorialButtonProps {
  className?: string;
  variant?: 'default' | 'outline' | 'ghost';
  showIcon?: boolean;
}

export const TutorialButton: React.FC<TutorialButtonProps> = ({
  className,
  variant = 'outline',
  showIcon = true,
}) => {
  const { startTutorial, completed } = useTutorial();

  return (
    <Button
      variant={variant}
      onClick={startTutorial}
      className={cn(
        "text-sm",
        variant === 'default' ? "bg-orange-500 hover:bg-orange-600" : "",
        className
      )}
    >
      {showIcon && <HelpCircle className="mr-2 h-4 w-4" />}
      {completed ? 'Restart the Tour' : 'Take the Tour'}
    </Button>
  );
};
